export default __webpack_public_path__ + "static/media/修匹承.993089f0.jpg";